import List from 'containers/JobTemplates';
import Create from 'containers/JobTemplates/components/Create';
import Show from 'containers/JobTemplates/components/Show';
import ExistingJobTemplateGrid from 'containers/JobTemplates/components/ExistingJobTemplateGrid';

export default { List, Create, Show, ExistingJobTemplateGrid };
